import SetupPayroll from "./SetupPayroll";

export default SetupPayroll;
